import { useEffect, useSyncExternalStore } from 'react'

// A page that pins its OWN bottom bar on phones (the saved deck page's
// DeckActionBar, plan 2026-10-15) hides the site's MobileNav while that bar is
// mounted, so two fixed bars never stack above the adhesion ad. The page's own
// Back control carries navigation instead.
//
// A mounted-component flag rather than a route match: the deck route also
// renders a loading spinner, a not-found page and a broken-analysis screen,
// none of which have a bar, and every one of those must keep the nav. The
// flag is set exactly while a bar is on screen and cleared on unmount, so a
// route change can never strand the nav hidden. Ref-counted so two holders
// (Strict Mode's double effect, a remount) compose.

let holders = 0
const listeners = new Set<() => void>()
const emit = () => { for (const l of listeners) l() }

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

/** Hide MobileNav while `active` is true and this component is mounted. */
export function useSuppressMobileNav(active: boolean) {
  useEffect(() => {
    if (!active) return
    holders += 1
    emit()
    return () => {
      holders -= 1
      emit()
    }
  }, [active])
}

/** True while any mounted component suppresses MobileNav. */
export function useMobileNavSuppressed(): boolean {
  return useSyncExternalStore(subscribe, () => holders > 0, () => false)
}
